import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import Editor from 'ckeditor5-huby-build/build/ckeditor';
import { AbstractNgModelComponent } from '../abstract-ng-model/abstract-ng-model.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';

@Component({
  selector: 'app-ckeditor',
  templateUrl: './ckeditor.component.html',
  styleUrls: ['./ckeditor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CkeditorComponent,
    },
  ],
})
export class CkeditorComponent
  extends AbstractNgModelComponent
  implements OnChanges, AfterViewInit
{
  public Editor = Editor;
  @Input() content = '';

  constructor(private api: WorkorderApiService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.config = {
      language: {
        content: this.content,
      },
      simpleUpload: {
        uploadUrl: '/api/workorder/qiniu',
        headers: {},
      },
    };
  }

  value = '';
  config: any;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.content === 'ar') {
        const toolbarItems = document.documentElement.querySelector(
          '.ck-toolbar__items'
        ) as HTMLElement;
        if (toolbarItems) {
          toolbarItems.style.direction = 'rtl';
        }
      }
    });
  }
}
